import { ReactComponent as SvgSearch } from '@img/icons/search-submit.svg';
import * as React from 'react';
import S from './PostcodeSearch.styles';
const PostcodeSearch = ({ prefix, placeholder, searchResultsUrl, }) => {
    const [value, setValue] = React.useState('');
    return (React.createElement(S.Container, null,
        React.createElement(S.Form, { action: searchResultsUrl, method: "get" },
            React.createElement(S.Submit, { buttonType: "inverted", icon: React.createElement(SvgSearch, null), iconOnly: true, type: "submit" }, "Submit"),
            React.createElement(S.Prefix, null, prefix),
            React.createElement(S.Input, { id: "postcode-search", name: "location", placeholder: placeholder, type: "search", value: value, onChange: (event) => {
                    setValue(event.target.value);
                } }))));
};
export default PostcodeSearch;
